import { useState, useCallback } from 'react';
import { getWeekDates } from '../utils/dateFormatters';

export const useWeekNavigation = (initialWeek: number = 0) => {
  const [currentWeek, setCurrentWeek] = useState(initialWeek);

  const goToPreviousWeek = useCallback(() => {
    setCurrentWeek(prev => prev - 1);
  }, []);

  const goToNextWeek = useCallback(() => {
    setCurrentWeek(prev => prev + 1);
  }, []);

  const goToToday = useCallback(() => {
    setCurrentWeek(0);
  }, []);

  const getWeekDatesForCurrent = useCallback(() => {
    return getWeekDates(currentWeek);
  }, [currentWeek]);

  return {
    currentWeek,
    setCurrentWeek,
    goToPreviousWeek,
    goToNextWeek,
    goToToday,
    getWeekDates: getWeekDatesForCurrent,
    isCurrentWeek: currentWeek === 0
  };
};